import { CheckoutExtensionCommonConfig } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';
import PlacementMode = CheckoutExtensionCommonConfig.PlacementMode;

export const PlacementModeConfig = [
  {
    text: 'Standalone',
    subText: '',
    value: PlacementMode.STANDALONE,
    defaultChecked: true,
    checked: (val: string) => {
      return val === PlacementMode.STANDALONE;
    },
  },
  {
    text: 'Inside shipping method',
    subText: '',
    value: PlacementMode.LINKED,
    defaultChecked: false,
    checked: (val: string) => {
      return val === PlacementMode.LINKED;
    },
  },
];
